import { render, staticRenderFns } from "./DashboardFidStatsCard.vue?vue&type=template&id=60748163&"
import script from "./DashboardFidStatsCard.vue?vue&type=script&lang=js&"
export * from "./DashboardFidStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports